import type { AgentReportData } from './agent-report.interface'

export const isAgentReportData = (data: unknown): data is AgentReportData => {
  if (typeof data !== 'object' || data === null) return false

  const record = data as Record<string, unknown>
  return (
    typeof record.id === 'string' &&
    typeof record.agentName === 'string' &&
    typeof record.content === 'string' &&
    (record.isLoading === undefined || typeof record.isLoading === 'boolean')
  )
}
